export const styleTheme = {
  colors: {
    white: "#fff",
    black: "#585858",
    gray: {
      dark: "#ABABAB",
      base: "#D9D9D9",
      baseLight: "#E6E6E6",
      light: "#F5F5F5",
    },
    teal: {
      base: "#1BABBC",
      light: "#E2F5F7",
    },
    pink: {
      base: "#E56274",
      light: "#FDE0E4",
    },
    orange: {
      base: "#F1843B",
      light: "#FFE9DB",
    },
    green: {
      base: "#1BB92A",
      light: "#DAF4DD"
    },
    red: {
      base: "#FF5757",
      light: "#FFF2F1"
    },
    blue: {
      base: "#0090FF",
      light: "#E8F5FF"
    },
  }
} as const

type AppTheme = typeof styleTheme

declare module "styled-components" {
  interface DefaultTheme extends AppTheme {}
}